import { useFocusedChatState } from './hooks/useFocusedChatState';

export function sendMessageToFocusChat(message: string) {
  return useFocusedChatState.getState().sendMessage(message);
}

export function focusedChatIsVisible() {
  return useFocusedChatState.getState().is_visible;
}
